// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploadSection[data-v-507e9b3c]{margin-top:20px;border:1px solid var(--el-border-color-light);border-radius:10px;padding:20px}.step[data-v-507e9b3c]{border:solid 1px var(--el-color-warning);border-radius:30px;width:28px;height:28px;background-color:var(--el-color-warning);color:#fff;display:inline-block;text-align:center;margin:0 10px 0 0}", ""]);
// Exports
module.exports = exports;
